export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteSelfProfileDialog.json?hash=9d5556fd45a971ec3cef50ce739875ae";